"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fullName = function (names) {
    var splitedNames = names.trim().toLowerCase().split(' ');
    var isFullName = splitedNames.length < 2;
    return {
        hasError: isFullName,
        message: 'Nome está incompleto. Digite o nome e sobrenome.',
    };
};
var hasAbbreviatedNames = function (names) {
    var splitedNames = names.toLowerCase().split(' ');
    var isFullName = splitedNames.filter(function (name) { return name.length < 2 && name.length > 0 && name !== 'e'; }).length > 0;
    return {
        hasError: isFullName,
        message: 'O campo não pode conter abreviações.',
    };
};
var hasDuplicatedNames = function (names) {
    var splitedNames = names.toLowerCase().split(' ');
    var mainName = splitedNames[0], surnames = splitedNames.slice(1);
    var hasDuplicateNamesLocal = surnames.includes(mainName);
    return {
        hasError: hasDuplicateNamesLocal,
        message: 'O campo não pode conter nomes repetidos. Ex: João João Silva',
    };
};
var hasSpecialCaracters = function (names) {
    var IS_VALID_NAME_REGEX = /^[a-zA-ZâÂàÀáÁãÃêÊèÈéÉîÎìÌíÍõÕôÔòÒóÓüÜûÛúÚùÙçÇ' ]*$/;
    var isValid = IS_VALID_NAME_REGEX.test(names);
    return {
        hasError: !isValid,
        message: 'Digite nomes contendo apenas letras. Não é permitido uso de caracteres especiais.',
    };
};
var validateName = function (value) {
    var rules = [hasSpecialCaracters, fullName, hasDuplicatedNames, hasAbbreviatedNames];
    var errorMessage = false;
    for (var _i = 0, rules_1 = rules; _i < rules_1.length; _i++) {
        var rule = rules_1[_i];
        var ruleResult = rule(value);
        if (ruleResult.hasError) {
            errorMessage = ruleResult.message;
            break;
        }
    }
    return errorMessage;
};
exports.default = validateName;
//# sourceMappingURL=name.js.map